<template>
  <sui-page>
    <sui-page-header title="Grid UI"></sui-page-header>
    <sui-page-contents>
      <div class="comm_title_wrap">
        <span class="sui-input-label__star"></span><h4>기본형</h4>
      </div>
      <sui-grid         
        ref="grid"
        :initial-pagesize="10"
        :multiselect="true"
        :showCountControl="true"
        :showDisplayCountControl="true"
        :showMoveControl="true"
        :columns="gridColumns0"
        :dataset="'dataset0'"
      >
      <div class="btn_wrapR">
        <button type="button" class="comm_btn_gridTop comm_ico_excel">엑셀 다운로드</button>
        <button type="button" class="comm_btn_gridTop">관련업무</button>
        <button type="button" class="comm_btn_gridTop_Brd">저장</button>
        <button type="button" class="comm_btn_gridTop" disabled="true">세부정보</button>
        <button type="button" class="comm_btn_gridTop_Brd" disabled="true">저장</button>
      </div>
     </sui-grid>
     <div class="btn_moreView">
       <p>더보기 (158/999)</p>
     </div>

      <div class="comm_title_wrap">
        <h4>셔틀형</h4>
      </div>
      <div class="comm_shut_wrap">
        <div class="inbox">
          <sui-grid  
             ref="grid1"
            :initial-pagesize="5"
            :multiselect="true"
            :showCountControl="true" 
            :showDisplayCountControl="false"                   
            :columns="gridColumns1"
            :dataset="'dataset1'"
          >
          </sui-grid>
        </div>
        <div class="btnbox">
          <ul>
            <li>
              <button type="button" class="comm_btn_shut_right">오른쪽보내기</button>
            </li>
            <li>
              <button type="button" class="comm_btn_shut_left">왼쪽보내기</button>
            </li>
          </ul>
        </div>
        <div class="inbox">
           <sui-grid  
             ref="grid2"    
            :initial-pagesize="5"
            :multiselect="true"
            :showCountControl="true" 
            :showDisplayCountControl="false"                   
            :columns="gridColumns2"
            :dataset="'dataset2'"
          >
          </sui-grid>
        </div>
      </div>
      <div class="comm_title_wrap">
        <h4>트리형</h4>
      </div>
      <sui-tree v-bind="fdpTree00" mutiple class="brdG01 pd20" style="height:250px; overflow-y:auto"></sui-tree>
    </sui-page-contents>
  </sui-page>
</template>
<script>
  export default {
    name: "TMP_COM_002",
    data() {
      return {  
        multiSelectOptions: [{
            key: 'm1',
            label: 'aulti1',
          },
          {
            key: 'm2',
            label: 'bulti2',
          },
          {
            key: 'm3',
            label: 'culti3',
          },
          {
            key: 'm4',
            label: 'dulti4',
          },
          {
            key: 'm11',
            label: 'aulti1',
          },
          {
            key: 'm12',
            label: 'bulti2',
          },
          {
            key: 'm13',
            label: 'culti3',
          },
          {
            key: 'm14',
            label: 'dulti4',
          },
          {
            key: 'm21',
            label: 'aulti1',
          },
          {
            key: 'm22',
            label: 'bulti2',
          },
          {
            key: 'm23',
            label: 'culti3',
          },
          {
            key: 'm24',
            label: 'dulti4',
          },
        ],
        multiSelected: [],    

        customOptions: [{
            key: 'D',
            label: '개발'
          },
          {
            key: 'F',
            label: '완료'
          },
        ],
        localdata0: [{           
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',         
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',   
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',   
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },
          {
          moduleCode: "CM",
          subModuleCode: "S",
          pageTypeCode: "N", 
          pageId: "PGE_CMS_00000",
          pageName: "배치작업이력",
          finalModificationUserId: "coolming.kim",
          finalModificationDTM: "2019-05-10 12:59:20",
          button: 'btn01',         
          multiselect: 'm1, m2, m4',         
          rangeDate: '2019-09-01~2019-09-15',
          datepicker: '2019-01-11',         
          badge: 'waiting',          
          timepicker: '11:20',
          buttonlink: 'link',
          },    
       
        ],
        gridColumns0: [{
          text: '모듈',
          datafield: 'moduleCode',
          width:"60px",
          headerClassName:'RE_error',
          // cellClassName:'GR_bg_complete'
        },
        {
          text: '서브모듈',
          datafield: 'subModuleCode',
          width:"120px",
          // cellClassName:'BL_bg_progress',         
          align:"center",
          cellsalign:"center"

        }, {
          text: '페이지타입',
          datafield: 'pageTypeCode',
          width:"90px",
          align:"center",
          cellsalign:"center",
           createwidget: (row, column, value, htmlElement) => {
            const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {}, this.dataset0, this.$refs.grid);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          
        }, {
          text: '페이지ID',
          datafield: 'pageId',
          // cellClassName:'RE_bg_error',
          
        }, {
          text: '페이지 명',
          datafield: 'pageName',
          // cellClassName:'GR_bg_except',         
         
        }, {
          text: '수정자',
          datafield: 'finalModificationUserId',
          cellClassName:'RE_error',
          width:"100px",
        },
        {
          text: '수정일시',
          datafield: 'finalModificationDTM',
          align:"right",
          cellsalign:"right"
        }],
        fdpTree00: {
          data: [{
            text: 'G-EHS',
            opened: true,
            children: [{
                text: 'Tree01 depth_1',
                opened: true,
                children: [{
                  text: 'Tree01 depth_2',
                  opened: true,
                  children: [{
                      text: 'Tree01 depth_30',
                      opened: true,
                      children: [{
                        text: 'Tree01 depth_40'
                      }, {
                        text: 'Tree01 depth_41'
                      }]
                    },
                    {
                      text: 'Tree01 depth_31'
                    }, {
                      text: 'Tree01 depth_32'
                    }, {
                      text: 'Tree01 depth_33'
                    }, {
                      text: 'Tree01 depth_34'
                    }
                  ]
                }, {
                  text: 'Tree01 depth_2'
                }]
              }, {
                text: 'Tree02 depth_1'
              },
              {
                text: 'Tree03 depth_1'
              },
              {
                text: 'Tree04 depth_1',
                opened: true,
                children: [{
                  text: 'Tree04 depth_21'
                }, {
                  text: 'Tree04 depth_22'
                }, {
                  text: 'Tree04 depth_233333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333'
                }]
              },
              {
                text: 'Tree05 depth_1'
              }
            ]
          }]
        },
        localdata1: [          
        ],
        gridColumns1: [{
          text: 'button',
          datafield: 'button',
           createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
                handler: this.onGridButtonClicked,
                type: 'button',
              }, this.dataset0, this.$refs.grid1);
            },
             initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
         
        }, {
          text: 'link',
          datafield: 'buttonlink',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                handler: this.onGridSingleButtonClicked,
                type: 'link',
              }, this.dataset0, this.$refs.grid1);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
           },
        }, {
            text: '멀티선택',
            datafield: 'multiselect',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellMultiSelect(row, column, value, htmlElement, {
                optionList: this.multiSelectOptions,
              }, this.dataset0, this.$refs.grid1);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '150px',
        }, {
          text: 'datepicker',
          datafield: 'datepicker',
          createwidget: (row, column, value, htmlElement) => {
              utils.getGridCellFactory().createCellDatePicker(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid1);
            },
             initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
        }],
        localdata2: [
        
        ],
        gridColumns2: [{
          text: 'button',
          datafield: 'button',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
                handler: this.onGridButtonClicked,
                type: 'link',
              }, this.dataset0, this.$refs.grid2);
            },
             initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          cellsalign: 'center',
          width: '100px',
        }, {
          text: 'badge',
          datafield: 'badge',
           createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {
                optionList: this.stateOptionList,
                handler: this.onGridStateClicked,
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid2);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            }, 
          width: '80px',  
        }, {
          text: 'timepicker',
          datafield: 'timepicker',
            createwidget: (row, column, value, htmlElement) => {
              utils.getGridCellFactory().createCellTimePicker(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid2);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            }, 
          width:'100px'  
        }, {
          text: '기간',
          datafield: 'rangeDate',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellRangeDatePicker(
              row,
              column,
              value,
              htmlElement, {
                checkEditableFunction: this.checkEditable,
                disabledDates: { from: '2019-12-31', to: '2019-01-01' },
              }, this.dataset0, this.$refs.grid2,
            );
          },
           initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
        }, ]
      };
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [ {
        name: 'moduleCode',
        type: 'string',
        map: 'moduleCode'
      }, {
        name: 'subModuleCode',
        type: 'string',
        map: 'subModuleCode'
      },{
        name: 'pageTypeCode',
        type: 'string',
        map: 'pageTypeCode'
      }, {
        name: 'pageId',
        type: 'string',
        map: 'pageId'
      }, {
        name: 'pageName',
        type: 'string',
        map: 'pageName'
      }, {
        name: 'finalModificationUserId',
        type: 'string',
        map: 'finalModificationUserId'
      },
      {
        name: 'finalModificationDTM',
        type: 'string',
        map: 'finalModificationDTM'
      }]
    }, {
      id: 'dataset1',
      type: 'local',
      data: 'localdata0',
      datafields: [ {
        name: 'button',
        type: 'string',
        map: 'button'
      },
      {
        name: 'buttonlink',
        type: 'string',
        map: 'buttonlink'
      }, 
      {
        name: 'multiselect',
        type: 'string',
        map: 'multiselect'
      },
      {
        name: 'datepicker',
        type: 'string',
        map: 'datepicker'
      },]
    }, {
      id: 'dataset2',
      type: 'local',
      data: 'localdata0',
      datafields: [
       {
        name: 'button',
        type: 'string',
        map: 'button'
      }, {
        name: 'badge',
        type: 'string',
        map: 'badge'
      }, {
        name: 'timepicker',
        type: 'string',
        map: 'timepicker'
      },
      {
      name: 'rangeDate',
      type: 'string',
      map: 'rangeDate',
    },]
    }],
    methods: {
      linkrenderer(row, column, value) {
        let format = {
          target: '"_blank"'
        };
        let html = jqx.dataFormat.formatlink(value, format);
        return html;
      },
    }
  };
</script>
<style scoped>
</style>
